import React, { useEffect, lazy, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ParentStyled from './style';
import {
  loadStyle,
  hasEnabledFeature,
  loadPageConfig,
  getNewObject,
  hasRestrictedRole
} from 'globalutils/fmUtils';
import { pageUrls, COOKIE_AUTH_DETAILS } from 'globalconfig/constants/keys';
import { getCookie } from 'globalservices/cookie';

const Styled = loadStyle(ParentStyled, 'pages/web/NoDefectInspections');
const layout = window?.$environment?.CURRENT_LAYOUT;

const config = loadPageConfig();
const Content = lazy(() => import(`@/${config.noDefectInspections[1].name}`));
const Tab = lazy(() => import(`globalcomponents/UI/Tab/${layout}`));

const NoDefectInspections = ({
  fetchInspections,
  getFilters,
  fetchDriverUserListing,
  getDocumentToken,
  history,
  i18n,
  theme,
  ...parentProps
}) => {
  const commonParentProps = { history, i18n, Styled, theme };

  const basicRequest = {
    displayLength:
      window.$environment.SERVICE_PROVIDER === 'spireon' ? '10' : '15',
    displayStart: '1',
    isNonDefective: 1
  };

  const [pagination, setPagination] = useState(false);
  const [request, setRequest] = useState({ ...basicRequest });

  const changeRequest = (fields) => {
    setRequest({ ...basicRequest, ...fields, isNonDefective: 1 });
  };

  const searchConfig = {
    setPagination,
    searchPlaceholder: 'Search Inspection Logs',
    changeRequest,
    fromData: false
  };

  useEffect(() => {
    const user = getCookie(COOKIE_AUTH_DETAILS);
    let requestToModify = { ...request };

    if (hasRestrictedRole(['MECHANIC'])) {
      requestToModify = { ...request, mechanicId: user?.userId };
    } else if (hasRestrictedRole(['DRIVER'])) {
      requestToModify = { ...request, userId: user?.userId };
    }

    fetchInspections({
      apiId: 'fetchInspections',
      data: { request: requestToModify }
    });
  }, [request, fetchInspections]);

  useEffect(() => {
    fetchDriverUserListing({ listApiId: 'fetchDriverUser' });
    getFilters({ apiId: 'getFilters' });
    getDocumentToken({ apiId: 'getDocToken' });
  }, [fetchDriverUserListing, getFilters, getDocumentToken]);

  const isCustomDviRequired = hasEnabledFeature('customDvirEnabled');
  const isAdvancedDviRequired = hasEnabledFeature('advancedDvirEnabled');

  return (
    <RenderComponentTab
      {...config.noDefectInspections[1]}
      parentProps={{
        ...parentProps,
        isAdvancedDviRequired,
        isCustomDviRequired,
        changeRequest,
        request,
        pagination,
        setPagination
      }}
      commonParentProps={commonParentProps}
      component={Content}
      history={history}
      i18n={i18n}
    />
  );
};

const RenderComponentTab = ({
  name,
  props,
  commonProps,
  parentProps,
  commonParentProps,
  component: Component,
  history,
  i18n,
  pagination,
  setPagination,
  ...rest
}) => {
  const tabValues = [
    { name: 'Pending Mechanic', url: pageUrls.pendingMechanicInspections },
    { name: 'Pending Driver', url: pageUrls.pendingDriverInspections },
    { name: 'Completed', url: pageUrls.completedInspections },
    { name: 'No Defect', url: pageUrls.noDefectInspections }
  ];

  const handleChange = (event, newValue) => {
    history.push(tabValues[newValue].url);
  };

  const newProps = {
    ...getNewObject(parentProps, props),
    ...getNewObject(commonParentProps, commonProps),
    ...rest
  };

  return (
    <Styled.Content>
      <Tab
        data={tabValues.map((tab) => ({
          ...tab,
          value: (
            <Component
              {...newProps}
              pagination={pagination}
              setPagination={setPagination}
            />
          )
        }))}
        className="logwrapper"
        currentTab={3}
        onChange={handleChange}
        vertical
      />
    </Styled.Content>
  );
};

const mapState = (state) => ({
  apiStatus: state.asyncRequests,
  inspections: state.inspectionList,
  list: state.inspections,
  filters: state.filters,
  logBook: state.logBook
});

const mapDispatch = (dispatch) => ({
  fetchInspections: (data) => dispatch.inspectionList.fetchData(data),
  bulkDownloadReport: (data) => dispatch.logBook.downloadData(data),
  fetchDriverUserListing: (data) => dispatch.inspections.fetchData(data),
  getFilters: (data) => dispatch.filters.fetchData(data),
  getDocumentToken: (data) => dispatch.logBook.documentToken(data),
  clearApiStatus: () => dispatch.asyncRequests.clearApiStatus(),
  viewReport: (data) => dispatch.viewReport.viewReportDocument(data)
});

NoDefectInspections.propTypes = {
  apiStatus: PropTypes.object.isRequired,
  fetchInspections: PropTypes.func.isRequired
};

export default connect(mapState, mapDispatch)(NoDefectInspections);